<template>
    <div class="main" v-if="isShow">
        <div class="wp4">
            <div class="page-tit dffs">
                <router-link class="back-btn" to="/userCenter/newUserIndex"></router-link>
                路演视频
            </div>
            <div class="user-tab">
                <div class="tab" :class="{ active: navType === 'capital' }" @click="changeType('capital')">主单元
                </div>
                <div class="tab" :class="{ active: navType === 'wip' }" @click="changeType('wip')">制作中项目单元</div>
                <div class="tab" :class="{ active: navType === 'science' }" @click="changeType('science')">科幻片单元</div>
            </div>
            <div class="act-list type2">
                <!-- 循环每个 item，生成对应的项目 -->
                <div class="item" v-for="item in listData" :key="item.id" @click="toDetail(item.id)">
                    <div class="inner">
                        <div class="pic">
                            <img :src="srcComputed(item.img)" />
                        </div>
                        <div class="text">
                            <div class="tit">
                                <span>{{ item.name }}</span>
                            </div>
                            <div class="info">
                                <p>导演：{{ item.director }}</p>
                                <p>题材：{{ item.type }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="main" style="display: flex;align-items: center;justify-content: center; height: 100%;" v-else>
        <div style="font-size: 22px;">敬请关注～</div>
    </div>
</template>

<script>
import filmJson from '@/static/newRoadShowFilm.json';
import { sessionData } from "@/static/js/local.js";

export default {
    data() {
        return {
            navType: 'capital',
            listData: [],
            isShow: true,
        }
    },
    created() {
        if (!this.$cookies.isKey("token")) {
            this.$router.push("/login");
            return
        }
        let detailForm = sessionData("get", "UserInfo");
        let isInvestor = detailForm?.details?.some(item => item.guestType == "10" && item.verifyFlag == 1);

        if (!isInvestor) {
            this.$msgbox({
                title: "提示",
                message: "您还不是一对一洽谈创投嘉宾，请先报名成为创投嘉宾再进行观看",
                showClose: false,
                confirmButtonClass: "btn-color",
                closeOnClickModal: false,
                closeOnPressEscape: false,
                callback: (action, instance) => {
                    if (action == "confirm") {
                        this.$router.push("/userCenter/newRegistration");
                    }
                }
            });
            return;
        }
        this.changeType('capital');

    },
    computed: {
        srcComputed() {
            return function (val) {
                return val
            }
        }
    },
    methods: {
        changeType(type) {
            this.navType = type ? type : 'capital';
            this.listData = filmJson[this.navType + 'Film'];
        },
        toDetail(id) {
            this.$router.push({
                path: '/userCenter/1v1/newRoadshowVideoDetail',
                query: {
                    type: this.navType,
                    id
                }
            });
        },
    }
}
</script>
<style scoped>
.item {
    cursor: pointer;
}
</style>
